import $ from 'jquery'
import { lockEl, unlockEl } from '../functions'

// eslint-disable-next-line no-undef
const object = ongmObject

const initializeBlock = function ($block) {
  const collapseWrapper = $block.find('.services-block__search')
  const collapseOpener = $block.find('.services-block__search-title')
  const collapseContent = $block.find('.services-block__search-content')
  const input = $block.find('.search-form > input[type=text]')
  const results = $block.find('.search-form__results')

  collapseOpener.on('click', function () {
    collapseContent.slideToggle(250)
    collapseWrapper.toggleClass('services-block__search--active')
  })

  input
    .autocomplete({
      minLength: 3,
      appendTo: results,
      source: function (request, response) {
        $.ajax({
          url: object.ajaxUrl,
          type: 'POST',
          dataType: 'JSON',
          data: {
            _ajax_nonce: object.nonce,
            action: 'ongm_get_posts',
            keyword: request.term,
            postType: 'service',
          },
          success: function (res) {
            response(res.data.data)
          },
        })
      },
      search: function (event) {
        $(event.target)
          .parents('.search-form')
          .addClass('search-form--searching')
      },
      open: function (event) {
        $(event.target).parents('.search-form').addClass('search-form--active')
        $(event.target).addClass('autocomplete-active')
      },
      close: function (event) {
        $(event.target)
          .parents('.search-form')
          .removeClass('search-form--active')
        $(event.target).removeClass('autocomplete-active')
      },
      response: function (event) {
        $(event.target)
          .parents('.search-form')
          .removeClass('search-form--searching')
      },
      create: function () {
        $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
          return $('<li>')
            .append(
              `<a href="${item.url}" data-id="${item.id}" class="ajax-post${
                !item.success ? ' ajax-post--error' : ''
              }">${
                item.thumbnail
                  ? `<img src="${item.thumbnail}" alt="${item.name}">`
                  : ''
              }<div><span class="ajax-post__title">${
                item.title
              }</span><span class="ajax-post__discover">${
                object.readMore
              }</span></div></a>`
            )
            .appendTo(ul)
        }
      },
    })
    .focus(function () {
      $(this).data('uiAutocomplete').search($(this).val())
    })
}

$('.services-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=cc-services', initializeBlock)
}

$('.feed-taxonomy-business-area').on('click', function () {
  const $this = $(this)
  const block = $this.parents('.services-block')
  const wrapper = block.find('.services-block__terms')
  const backWrapper = block.find('.services-block__back-wrapper')
  const first = block.find('.services-block__terms-row')
  const second = $('<div class="row services-block__posts-row"></div>')
  const id = $this.attr('data-id') * 1
  const permalink = $this.attr('data-permalink')
  const title = $this.find('.feed-taxonomy-business-area__title').text()
  const changeTitle = block.find('.services-block__back-term')
  const windowWidth = $(window).width()
  changeTitle.text(title)

  if (windowWidth < 768) {
    window.location.href = permalink
    return;
  }

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    dataType: 'JSON',
    data: {
      _ajax_nonce: object.nonce,
      action: 'ongm_get_services_by_term',
      id,
    },
    beforeSend: () => {
      lockEl(wrapper)
    },
    success: function (res) {
      first.hide()
      backWrapper.show()
      second.append(res.data.content).appendTo(wrapper)
      unlockEl(wrapper)
    },
  })
})

$('.services-block__back').on('click', function () {
  const $this = $(this)
  const block = $this.parents('.services-block')
  const backWrapper = block.find('.services-block__back-wrapper')
  const first = block.find('.services-block__terms-row')
  const second = block.find('.services-block__posts-row')

  backWrapper.hide()
  first.show()
  second.remove()
})
